// Definição para o modal de busca de Fornecedores
// Factory functions - recebem filtros como parâmetros, sem magic strings

import { ST } from '@/constants/ST'

export const fornecedorSearch = {
  label: 'Fornecedor',
  placeholder: 'ID ou Nome...',
  titulo: 'Selecionar Fornecedor Estrangeiro',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  displayField: 'idParceiro',
  descField: 'nomeFantasia',
  tabela: 'Parceiro',
  camposFiltro: [
    { label: 'Nome Fantasia', model: 'busca', tipo: 'text' },
    {
      label: 'Categoria',
      model: 'lstCategoria',
      tipo: 'select',
      optionsEndpoint: 'ListasCliente/lookup/PCAT'
    }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idParceiro', width: '10%' },
    { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '30%' },
    { header: 'Razão Social', dataField: 'razaoSocial', width: '30%' },
    { header: 'Categoria', dataField: 'lstCategoria', width: '30%' }
  ],
  filtrosFixos: {
    isFornecedor: true
  }
}

export const criarConfigBuscaFornecedorDocumentoEntrada = (temCompleto, idGrupoEmpresa = null, lstStatus = ST.Ativo) => {
  const filtros = {
    isFornecedor: true,
    lstStatus
  }

  if (!temCompleto && idGrupoEmpresa) {
    filtros.idGrupoEmpresa = idGrupoEmpresa
  }

  return {
    label: 'Fornecedor',
    placeholder: 'ID ou Nome...',
    titulo: 'Selecionar Fornecedor',
    endpointApi: 'Parceiros',
    idField: 'idParceiro',
    displayField: 'idParceiro',
    descField: 'nomeFantasia',
    tabela: 'Parceiro',
    camposFiltro: [
      { label: 'Nome Fantasia', model: 'busca', tipo: 'text' },
      {
        label: 'Categoria',
        model: 'lstCategoria',
        tipo: 'select',
        optionsEndpoint: 'ListasCliente/lookup/PCAT'
      }
    ],
    colunasGrid: [
      { header: 'ID', dataField: 'idParceiro', width: '10%' },
      { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '30%' },
      { header: 'Razão Social', dataField: 'razaoSocial', width: '30%' },
      { header: 'Categoria', dataField: 'lstCategoria', width: '30%' }
    ],
    filtrosFixos: filtros
  }
}
